import Vue from 'vue';
import billProductTransformer from './../../transformers/creditNoteProduct';

const success = (data, id, resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(billProductTransformer.fetch(errors));
};

export default (id, billProduct, billProductId) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .put(`/bills/${id}/products/${billProductId}`, billProductTransformer.send(billProduct))
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billProduct/update.js